module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"autoReply":"Auto-reply","viewContactRecord":"View {name}\u0027s info","addPhoneNumber":"Add {phoneNumber} to contacts"}}')
  delete Component.options._Ctor
}
